export default "__VITE_ASSET__ziyYB73A__"